import _ from 'lodash';
import Constants from '../constants';
import { DistributionType } from '../models';

export const DistributionHelper = {
	isSingleLinkWithDistribution: (distributionType?: DistributionType) => {
		return distributionType === DistributionType.SingleLink || distributionType === DistributionType.SingleLinkWithAccessCode;
	},
	hasAccessCode: (emailTemplateContent: string) => {
		return _.includes(emailTemplateContent, Constants.ACCESS_CODE_PLACEHOLDER);
	},
	usesDistributionList: (distributionType?: DistributionType) => {
		return (
			distributionType === DistributionType.SingleLink ||
			distributionType === DistributionType.SingleLinkWithAccessCode ||
			distributionType === DistributionType.Unique ||
			distributionType === DistributionType.SSO
		);
	},
	isNotAnonymous: (distributionType?: DistributionType) => {
		return (
			distributionType === DistributionType.Unique ||
			distributionType === DistributionType.SingleLinkWithAccessCode ||
			distributionType === DistributionType.SSO
		);
	},
	isAnonymous: (distributionType?: DistributionType) => {
		return (
			distributionType !== DistributionType.Unique &&
			distributionType !== DistributionType.SingleLinkWithAccessCode &&
			distributionType !== DistributionType.SSO
		);
	},
};
